import React, { Component } from 'react'
import SideNavbar from '../components/navbars/SideNavbar'
import NavbarOne from '../components/navbars/NavbarOne'
import Preloader from '../components/preloader/Preloader';
import QuestionsPreviewSection from '../components/questioners/create_question_paper/own_question_paper/own_question_types/QuestionsPreviewSection';
import Footer from '../components/footer/Footer'

import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import ReplaceQuestionsModal from '../components/questioners/create_question_paper/ReplaceQuestionsModal';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import { withApollo } from "react-apollo";


const REPLACE_QUESTIONS = gql`
  mutation(
    $params:ReplaceQuestionsInput  
    ) {
      replaceQuestions(
        params: $params
     ){
       
        exam_paper_id
        filename
        exam_questions{
            id
            subject
            chapter
            question
            option1
            option2
            option3
            option4
            qtype
            compquestion
            list1type
            list2type
            mat_question
            answer
            inputquestion
            chapter_name
        }
     }
  }
`;

const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
        exams{
            id
            exam
            exam_subjects{
                subject_id
            }
            avg_question_time
        }
        globalBranches{
            id
            branch_name
        }
        classes{
            id
            class
        }
        globalSections{
            id
            section_name
        }
        subjects{
            id
            subject
            chapters{
                id
                chapter
                topics{
                    id
                    topic
                }
                class
            }
            state_chapters{
                id
                chapter
                exam_id
                state_topics{
                    id
                    topic
                }
                class
            }
        }
        questionTypes{
            id
            questiontype
        }
        questionTheory{
            id
            question_theory
        }
    }
}

`;


class QuestionsPreview extends Component {
  constructor(props) {
    super(props)
    const state = props.history?.location?.state || {};
    let exam_questions = state.exam_questions || [];
    let examquestionsArray = [];

    if (exam_questions.length > 0) {
      examquestionsArray = exam_questions.map((item) => {
        return { ...item, checked: false }
      })
    }

    this.state = {
      submitError1: "",
      exam_paper_id: state.exam_paper_id,
      subjects: [],
      currentStep: 1,
      searchsubject: "0",
      searchsubjectvalue: "",
      searchchapter: "",
      searchchaptervalue: "",
      questiontypes: "",
      questiontypesvalue: "",
      applicationtheory: "",
      applicationtheoryvalue: "",
      examquestionsArray: examquestionsArray,
      searchquestionid: "",
      modalShow: false,
      questionbankquestions: true,
      ownaddedquestions: false,
      spinnerStatus: "",
      searchsubjectown: "0",
      searchsubjectownvalue: "",
      ownaddedArray: [],
      questionBankAddedArray: [],
      getTopicsArr: [],
      qbsearchtopic: [],
      qbsearchtopicvalue: [],
      typeOfQuestions: 7,
      searchQuestionvalue: { value: 7, label: 'General' },
      exam_type: state.examtype,
      selectedQuestionCount: 0,
      submitError2: "",
      getQuestionBankQuestions: [],
      showSpinner: "hide"
    }
  };

  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };

  componentDidMount() {
    console.log("QuestionsPreview state", this.props.history.location.state);

    const { subjects = [], exam_questions = [] } = this.props.history.location.state || {};

    let uniqueSubject_ids = [...new Set(exam_questions.map(item => item.subject))];
    console.log("uniqueSubject_ids", uniqueSubject_ids);

    let subjectsArray = [];
    subjects.map((item) => {
      uniqueSubject_ids.map((item1) => {
        if (item.id == item1) {
          subjectsArray.push({ ...item });
        }
      })
    });

    console.log("subjectsArray", subjectsArray);

    if (subjectsArray.length > 0) {
      this.setState({
        searchsubjectvalue: {
          value: subjectsArray[0].id,
          label: subjectsArray[0].subject
        },
        searchsubjectownvalue: {
          value: subjectsArray[0].id,
          label: subjectsArray[0].subject
        },
        searchsubject: subjectsArray[0].id,
        subjects: subjectsArray
      });
    } else if (subjects.length > 0) {
      // Fallback if no subjects matched uniqueSubject_ids
      this.setState({
        searchsubjectvalue: {
          value: subjects[0].id,
          label: subjects[0].subject
        },
        searchsubjectownvalue: {
          value: subjects[0].id,
          label: subjects[0].subject
        },
        searchsubject: subjects[0].id,
        subjects: subjects
      });
    }
  }

  replaceQuestions = (e) => {
    let status = false;
    let dataArray = [];
    //console.log("replace", this.state.examquestionsArray);
    this.state.examquestionsArray.map(
      (item) => {
        if (item.checked == true) {
          dataArray.push(item.id);
        }
      }
    );
    if (dataArray.length > 0) {
      status = true;
    }
    if (status) {
      this.setState({ modalShow: true, submitError1: "", selectedQuestionCount: dataArray.length })
    }
    else if (!status) {
      this.setState({
        submitError1: "Please select at least one question to replace the question", spinnerStatus: ""
      });
    }

  }

  QuestionFunction = (e, questionsdata) => {
    let examquestions = this.state.examquestionsArray.map((item) => {
      if (item.id == questionsdata) {
        if (e.target.checked == true) {
          return {
            ...item, checked: true
          }
        }
        else {
          return {
            ...item, checked: false
          }
        }
      } else {
        return {
          ...item
        }
      }
    });
    this.setState({ examquestionsArray: examquestions, submitError1: "" });
  }


  onScrollgetQuestionById = async (startedCount) => {

    console.log("sesssssssssssss", this.state.searchchapter);
    // this.setState({ validateSubject: "", validateChapter: "", validateTopic: "", validateTypeOfQuestion: "", validateComplexity: "", getQuestionBankQuestions: "", showSpinner: "hide", validationMessage: "", paginationShowBlock: "", showQuestionsNotAvailable: "yes" });



    if (this.state.searchchapter == "") {
      this.setState({ submitError2: "Please Select Chapter" });
      return;
    }
    if (!this.state.qbsearchtopic.length) {
      this.setState({ submitError2: "Please Select Topic" });
      return;
    }
    //  else if (this.state.typeOfQuestionvalue == "") {
    //     this.setState({ validateTypeOfQuestion: "Please Select Type of Question" });
    //     return;
    // }
    /*else if(this.state.complexityvalue == ""){
        this.setState({validateComplexity:"Please Select Complexity" });
        return;
    }*/

    this.setState({ showSpinner: "show" });

    console.log("handleMultipleSelectInputChange222", this.state.qbsearchtopic)
    console.log("handleMultipleSelectInputChange111", this.state.qbsearchtopic.toString())

    const result = await this.props.client.query({
      query: gql` 
    query(
        $subject:String!,
        $chapter:String!,
        $topic:String!,
        $question_type:String,
        $question_theory:String,
        $complexity: String,
        $institute_id: Int!,
        $page: Int,
        $type: Int,
        $exam_type:Int 
        
        ) {
            getQuestionBankQuestions(
                subject: $subject,
                chapter: $chapter,
                topic: $topic,
                question_type: $question_type,
                question_theory: $question_theory,
                complexity:$complexity,
                institute_id: $institute_id,
                page:$page,
                type: $type,
                exam_type:$exam_type
            )
            {
                id
                subject
                question
                chapter
                topic
                complexity
                question_theory
                qtype
                mat_question
                compquestion
                list1type
                list2type
                subject_name
                chapter_name
                topic_name
                option1
                option2
                option3
                option4
                answer
                usageset
        }
    }
`,
      variables: {

        subject: this.state.searchsubject,
        chapter: this.state.searchchapter,
        topic: this.state.qbsearchtopic.toString(),
        question_type: this.state.searchQuestionvalue.value.toString(),
        question_theory: "0",
        complexity: "",
        institute_id: parseInt(Cookies.get("institutionid")),
        page: 1,
        type: 1,
        exam_type: parseInt(this.state.exam_type)

      },
      fetchPolicy: 'network-only'
    });

    console.log("aaaaa", result);

    if (result.data.getQuestionBankQuestions.length > 0) {
      this.setState({
        showSpinner: "hide",
        getQuestionBankQuestions: result.data.getQuestionBankQuestions,
        paginationShowBlock: "0"
      });
    } else {
      this.setState({
        showQuestionsNotAvailable: "no",
        getQuestionBankQuestions: "",
        showSpinner: "hide"
      });
    }

  }

  ownQuestionFunction = (e, questionsdata) => {
    console.log("ownQuestionFunction", e, questionsdata);
    let newarray = this.state.ownaddedArray;
    let filterData = this.state.ownaddedArray.filter((a) => a.id == questionsdata.id);
    if (e.target.checked == true) {
      if (filterData.length == 0) {
        newarray.push({ question_id: questionsdata.id, subject: questionsdata.subject, chapter: questionsdata.chapter, type: 1, qtype: questionsdata.qtype });
      }
    }
    else {
      let ownedarray = this.state.ownaddedArray.filter((a) => a.question_id != questionsdata.id);
      newarray = ownedarray;
    }

    //console.log("ownquestions", newarray);
    this.setState({ ownaddedArray: newarray, submitError1: "" });
  }

  questionBankQuestionsFunction = (e, questionsdata) => {
    console.log("hello", questionsdata);
    let newarray = this.state.questionBankAddedArray;
    let filterData = this.state.questionBankAddedArray.filter((a) => a.question_id == questionsdata.id);
    if (e.target.checked == true) {
      if (filterData.length == 0) {
        newarray.push({ question_id: questionsdata.id, subject: questionsdata.subject, chapter: questionsdata.chapter, type: 2, qtype: questionsdata.qtype });
      }
    }
    else {
      let questionBankAddedArray = this.state.questionBankAddedArray.filter((a) => a.question_id != questionsdata.id);
      newarray = questionBankAddedArray;
    }

    //console.log("ownquestions", newarray);
    this.setState({ questionBankAddedArray: newarray, submitError1: "" });
  }

  handleMultipleSelectInputChange = (e, name) => {

    if (name == "topic") {
      let qbsearchtopic = Array();
      let qbsearchtopicvalue = Array();
      if (e != null) {
        for (let i = 0; i < e.length; i++) {
          const qbtopicval = e[i];
          const newObj = {
            label: qbtopicval.label,
            value: qbtopicval.value
          }
          qbsearchtopicvalue.push(newObj);
          qbsearchtopic.push(qbtopicval.value);
        }
        this.setState({
          qbsearchtopicvalue: qbsearchtopicvalue,
          qbsearchtopic: qbsearchtopic,
          submitError2: "",
          getQuestionBankQuestions: []
        });
      }
    }

  }

  handleFormSubmit = e => {
    e.preventDefault();
    //console.log("Form submitted");

    let dataArray = [];
    this.state.examquestionsArray.map(
      (item) => {
        if (item.checked == true) {
          dataArray.push(item.id);
        }
      }
    );

    console.log("dddd", this.state.questionBankAddedArray.length + this.state.ownaddedArray.length, dataArray.length);

    if ((this.state.questionBankAddedArray.length + this.state.ownaddedArray.length) == dataArray.length) {


      let questionsdata = this.state.questionBankAddedArray.concat(this.state.ownaddedArray);

      console.log("questionsdata", questionsdata);

      let replacequestionsobject = "";
      replacequestionsobject = {
        exam_paper_id: parseInt(this.props.history.location.state.exam_paper_id),
        replace_questions: dataArray.toString(),
        own_questions: true,
        institution_questions: questionsdata,
        username: Cookies.get("username")
      }
      //console.log('replacequestionsobject', replacequestionsobject);
      this.replacequestionsFun(
        replacequestionsobject
      ).catch(error => {
        //console.log("catch if error");
        //console.log(error);
        this.setState({
          submitError1: error.graphQLErrors.map(x => x.message), spinnerStatus: ""
        });
        //console.error("ERR =>", error.graphQLErrors.map(x => x.message));
      });

    } else {
      this.setState({ submitError1: "Please ensure that the number of questions count being replaced and the number of newly selected questions count match", spinnerStatus: "" });

    }
    // if (this.state.questionbankquestions == true || this.state.ownaddedquestions == true) {

    //   if (this.state.ownaddedquestions == true) {

    //     this.setState({
    //       spinnerStatus: "1"
    //     });

    //     let own_questions = false;
    //     if (this.state.ownaddedquestions == true) {
    //       own_questions = true;
    //     }
    //     //console.log("lengthss", dataArray.length, this.state.ownaddedArray.length);
    //     if (dataArray.length == this.state.ownaddedArray.length) {


    //       let replacequestionsobject = "";
    //       replacequestionsobject = {
    //         exam_paper_id: parseInt(this.props.history.location.state.exam_paper_id),
    //         replace_questions: dataArray.toString(),
    //         own_questions: own_questions,
    //         institution_questions: this.state.ownaddedArray.toString(),
    //         username: Cookies.get("username")
    //       }
    //       //console.log('replacequestionsobject', replacequestionsobject);
    //       this.replacequestionsFun(
    //         replacequestionsobject
    //       ).catch(error => {
    //         //console.log("catch if error");
    //         //console.log(error);
    //         this.setState({
    //           submitError1: error.graphQLErrors.map(x => x.message), spinnerStatus: ""
    //         });
    //         //console.error("ERR =>", error.graphQLErrors.map(x => x.message));
    //       });
    //     }
    //     else {
    //     }

    //   }
    //   else if (this.state.questionbankquestions == true) {
    //     this.setState({
    //       spinnerStatus: "1"
    //     });
    //     let dataArray = [];
    //     this.state.examquestionsArray.map(
    //       (item) => {
    //         if (item.checked == true) {
    //           dataArray.push(item.id);
    //         }
    //       }
    //     );
    //     let own_questions = false;
    //     if (this.state.ownaddedquestions == true) {
    //       own_questions = true;
    //     }
    //     let replacequestionsobject = "";
    //     replacequestionsobject = {
    //       exam_paper_id: parseInt(this.props.history.location.state.exam_paper_id),
    //       replace_questions: dataArray.toString(),
    //       own_questions: own_questions,
    //       institution_questions: "",
    //       username: Cookies.get("username")
    //     }
    //     //console.log('replacequestionsobject', replacequestionsobject);
    //     this.replacequestionsFun(
    //       replacequestionsobject
    //     ).catch(error => {
    //       //console.log("catch if error");
    //       //console.log(error);
    //       this.setState({
    //         submitError1: error.graphQLErrors.map(x => x.message), spinnerStatus: ""
    //       });
    //       //console.error("ERR =>", error.graphQLErrors.map(x => x.message));
    //     });
    //   }

    // } else {
    //   this.setState({ submitError1: "Please check question bank questions or own added questions", spinnerStatus: "" });
    // }
  };

  replacequestionsFun = async (
    params) => {
    await this.props.replacequestionsFun({
      variables: {
        params
      },
      update: (store, { data }) => {
        if (data.replaceQuestions) {
          //console.log("repldata", data, data.replaceQuestions.exam_questions);
          const examquestionsArray1 = data.replaceQuestions.exam_questions.map((item) => {
            return { ...item, checked: false }

          })
          this.setState({
            submitError1: "",
            exam_paper_id: data.replaceQuestions.exam_paper_id,
            subjects: this.props.history.location.state.subjects,
            searchsubject: "0",
            searchsubjectvalue: "",
            searchchapter: "0",
            searchchaptervalue: "",
            questiontypes: "",
            questiontypesvalue: "",
            applicationtheory: "",
            applicationtheoryvalue: "",
            examquestionsArray: examquestionsArray1,
            searchquestionid: "",
            //modalShow: false,
            questionbankquestions: false,
            ownaddedquestions: false,
            spinnerStatus: "",
            currentStep: 5,
            filename: data.replaceQuestions.filename,
            ownaddedArray: []
          });
          setTimeout(() => { this.SetpageLoad1() }, 1000);
        }
      }
    });
  };
  SetpageLoad1 = () => {
    this.setState({ currentStep: 1, modalShow: false });
    this.props.history.push("/questions/manage-question-paper");
  }

  selecthandleInputChange = (ename, evalue) => {
    //console.log("selecthandleInputChange", ename, evalue);
    const name = ename;
    const value = evalue;

    if (name == "filterQuestionTypes") {
      let types = [{ value: 7, label: "General" }, { value: 8, label: "Integer" }]
      let questionTypes = types.find((a) => a.value == value);

      let examquestions = this.state.examquestionsArray.map((item) => {
        return {
          ...item, checked: false
        }
      })

      this.setState({
        searchQuestionvalue: {
          value: questionTypes.value,
          label: questionTypes.label
        },
        typeOfQuestions: questionTypes.value,
        examquestionsArray: examquestions,

      });

    }

    if (name == "searchsubject") {
      let subjectData = this.props.globals.globals.subjects.find((a) => a.id == value);
      let examquestions = this.state.examquestionsArray.map((item) => {
        return {
          ...item, checked: false
        }
      })
      this.setState({
        searchsubjectvalue: {
          value: subjectData.id,
          label: subjectData.subject
        },
        searchQuestionvalue: { value: 7, label: 'General' },
        typeOfQuestions: 7,
        examquestionsArray: examquestions

      });

    }
    if (name == "searchsubjectown") {
      let subjectData = this.props.globals.globals.subjects.find((a) => a.id == value);
      this.setState({
        searchsubjectownvalue: {
          value: subjectData.id,
          label: subjectData.subject
        }
      });
    }
    if (name == "searchchapter") {
      let subjectData = this.props.globals.globals.subjects.find((a) => a.id == parseInt(this.state.searchsubject));
      let chData = '';
      if (this.state.exam_type == 1 || this.state.exam_type == 2) {
        chData = subjectData.chapters.find((a) => a.id == value);
      } else {
        chData = subjectData.state_chapters.find((a) => a.id == value);
      }
      this.setState({
        searchchaptervalue: {
          value: chData.id,
          label: chData.chapter
        },
        submitError2: "",
        qbsearchtopicvalue: [],
        qbsearchtopic: [],
        getQuestionBankQuestions: []

      });
      setTimeout(() => {
        this.getTopics();
      }, 1000);
    }
    if (name == "questiontypes") {
      let questionData = this.props.globals.globals.questionTypes.find((a) => a.id == value);
      this.setState({
        questiontypesvalue: {
          value: questionData.id,
          label: questionData.questiontype
        }
      });
    }
    if (name == "applicationtheory") {
      let theoryData = this.props.globals.globals.questionTheory.find((a) => a.id == value);
      this.setState({
        applicationtheoryvalue: {
          value: theoryData.id,
          label: theoryData.question_theory
        }
      });
    }
    this.setState({ [name]: value });
  }

  handleInputChange = (e) => {
    //console.log("handleInputChange", e.target.name, e.target.value);
    const name = e.target.name;
    const value = e.target.value;
    if (name == "questionbankquestions") {
      if (e.target.checked == true) {
        this.setState({ questionbankquestions: true, ownaddedquestions: false, searchchaptervalue: "", searchchapter: "", getTopicsArr: [], qbsearchtopic: [], qbsearchtopicvalue: [] });
      }
      else {
        this.setState({ questionbankquestions: false });
      }
    }
    if (name == "ownaddedquestions") {
      if (e.target.checked == true) {
        this.setState({
          ownaddedquestions: true, questionbankquestions: false, searchchaptervalue: "", searchchapter: "", getTopicsArr: [], qbsearchtopic: [], qbsearchtopicvalue: [], getQuestionBankQuestions: [],
        });
      }
      else {
        this.setState({ ownaddedquestions: false });
      }
    }
    this.setState({ searchquestionid: value });
  };


  // getTopics = () => {
  //   let getArray = [];
  //   for (let i = 0; i <= this.props.globals.globals.subjects.length; i++) {
  //     let idata = this.props.globals.globals.subjects[i];
  //     if (idata != undefined) {
  //       if (idata.id == this.state.searchsubject) {
  //         idata.chapters.map((chmapData) => {
  //           if (chmapData.id == this.state.searchchapter) {
  //             chmapData.topics.map((topicData) => {
  //               const newObj = {
  //                 value: topicData.id,
  //                 label: topicData.topic
  //               }
  //               getArray.push(newObj);
  //             })
  //           }

  //         })

  //       }
  //     }

  //   }
  //   //console.log("aravind", getArray)
  //   this.setState({
  //     getTopicsArr: getArray
  //   });
  // }

  getTopics = () => {
    let getArray = [];
    for (let i = 0; i <= this.props.globals.globals.subjects.length; i++) {
      let idata = this.props.globals.globals.subjects[i];
      console.log("idata", idata);
      if (idata != undefined) {
        if (idata.id == this.state.searchsubject) {


          if (this.state.exam_type == 1 || this.state.exam_type == 2) {

            idata.chapters.map((chmapData) => {
              if (chmapData.id == this.state.searchchapter) {
                chmapData.topics.map((topicData) => {
                  const newObj = {
                    value: topicData.id,
                    label: topicData.topic
                  }
                  getArray.push(newObj);
                })
              }

            })
          } else {
            idata.state_chapters.map((chmapData) => {
              if (chmapData.id == this.state.searchchapter) {
                chmapData.state_topics.map((topicData) => {
                  const newObj = {
                    value: topicData.id,
                    label: topicData.topic
                  }
                  getArray.push(newObj);
                })
              }

            })
          }



        }
      }

    }
    console.log("aravind", getArray)
    this.setState({
      getTopicsArr: getArray
    });
  }





  render() {
    if (Cookies.get("token") == undefined) this.props.history.push("/login");
    const globals = this.props.globals;
    const loading3 = globals.loading;
    const error3 = globals.error;
    if (error3 !== undefined) {
      alert("Server Error. " + error3.message);
      return null;
    }

    let examquestionsData = this.state.examquestionsArray;

    if (this.state.searchsubject != "0" ||
      this.state.searchchapter != "0" ||
      this.state.questiontypes != "" ||
      this.state.applicationtheory != "") {

      this.state.examquestionsArray.map((item) => {
        if (this.state.searchsubject != "0") {

          examquestionsData = this.state.examquestionsArray.filter((a) => a.subject == this.state.searchsubject);

          if (this.state.typeOfQuestions == 8) {
            examquestionsData = examquestionsData.filter((b) => b.qtype == 8)
          } else {
            examquestionsData = examquestionsData.filter((b) => b.qtype != 8)

          }

          //console.log("mahesh", examquestionsData);

        }
        // if (this.state.searchchapter != "0") {
        //   //console.log("mahesh1");
        //   examquestionsData = this.state.examquestionsArray.filter((a) => a.chapter == this.state.searchchapter);
        // }
        // if (this.state.questiontypes != "") {
        //   //console.log("mahesh2");
        //   examquestionsData = this.state.examquestionsArray.filter((a) => a.qtype == this.state.questiontypes);
        // }
        // if (this.state.applicationtheory != "0") {
        //   examquestionsData = this.state.examquestionsArray.filter((a) => a.subject == this.state.applicationtheory);
        // }

      });
    }
    //console.log("parentcurrentState", this.state);
    let latestData = "";
    if (this.state.searchquestionid != "") {
      //console.log("examquestionsData", examquestionsData);
      latestData = examquestionsData.filter((a) => a.id.toString().includes(this.state.searchquestionid));
    }
    else {
      latestData = examquestionsData;
    }

    console.log("parent", this.state);


    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">

          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          {(loading3 == true) && (<PreloaderTwo />)}
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
            {
              !loading3 && (
                <div className="main-content">
                  <QuestionsPreviewSection
                    pselecthandleInputChange={this.selecthandleInputChange}
                    globals={globals.globals}
                    stateData={this.state}
                    breadCrumbsData={this.props.history.location.state}
                    examquestionsData={latestData}
                    QuestionFunction={this.QuestionFunction}
                    handleInputChange={this.handleInputChange}
                    ParentreplaceQuestions={this.replaceQuestions} />
                  <ReplaceQuestionsModal
                    pselecthandleInputChange={this.selecthandleInputChange}
                    globalsData={globals.globals}
                    phandleInputChange={this.handleInputChange}
                    stateData={this.state}
                    onScrollgetQuestionById={this.onScrollgetQuestionById}
                    ParenthandleFormSubmit={this.handleFormSubmit}
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false, submitError1: "", questionbankquestions: true, ownaddedquestions: false, searchchaptervalue: "" })}
                    ownQuestionFunction={this.ownQuestionFunction}
                    questionBankQuestionsFunction={this.questionBankQuestionsFunction}
                    handleMultipleSelectInputChange={this.handleMultipleSelectInputChange}

                  />
                </div>
              )}
          </div>
          <Footer />

        </div>
      </div>
    )
  }
}
export default withRouter(withApollo(
  compose(
    graphql(REPLACE_QUESTIONS, {
      name: "replacequestionsFun"
    }),

    graphql(FETCH_GLOBALS,
      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))
          }
        }), name: "globals"
      })

  )
    (QuestionsPreview)));
